import React, {useEffect, useState} from "react";
import style from '../Login.scss';
import {logout} from "@/util/authentication";
import {useHistory} from "react-router";
import RegisterLayout from "@/layout/RegisterLayout";
import MButton from "@/components/atom/MButton";
import {Logo} from "@/components/atom/Logo";
import {useParams} from "react-router-dom";
import {resetPassword} from "@/api";

const ResetPassword = () => {
  const { code } = useParams()
  const history = useHistory()
  const [password, setPassword] = useState('')
  const [passwordConfirm, setPasswordConfirm] = useState('')

  useEffect(() => {
    logout()
  }, [])

  const canLogin = () => {
    return password !== '' && passwordConfirm !== ''
  }

  const doPasswordReset = async () => {
    await resetPassword({ code, password })
    history.push('/login')
  }

  return (
    <div className="App">
      <RegisterLayout category={''}>
        <div className={style.loginTop}>
          <div className={style.contents}>
            <div>
              <div className={`${style.mainTitle} ${style.titleLogoBlock}`}>
                <Logo/>
              </div>
              <div className={style.loginForm}>
                <div className={style.loginTitleLine}>
                  パスワードを再設定します。
                </div>
                <div className={style.loginTitleLine}>
                  <span className={style.loginTitle}>パスワード</span>
                  <input type="text" value={password} onChange={(e) => setPassword(e.target.value)}/>
                </div>
                <div className={style.loginTitleLine}>
                  <span className={style.loginTitle}>パスワード(再入力)</span>
                  <input type="text" value={passwordConfirm} onChange={(e) => setPasswordConfirm(e.target.value)}/>
                </div>
                <div>
                  <MButton image={'touroku.png'} value={'登録'} onClick={doPasswordReset} disabled={!canLogin()}></MButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </RegisterLayout>
    </div>
  )
}

export default ResetPassword;
